var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/images/error.png"),"alt":""}}),_vm._v(" "),_c('vbutton',{attrs:{"active":""},on:{"click":_vm.backHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }